
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Label, FormGroup, Col } from 'reactstrap';
// import {FaQuestionCircle, FaPrint} from 'react-icons/fa';
import { getUserPreferences, UpdateUserPreferences } from '../../../../action/cultureAction'
import '../../../../Assets/EnsembleStyles/Administration/administration.css';
import { Redirect } from 'react-router-dom';

let AvailableLang = [{ "Symb": "en-US", "Lang": "English (United States)" },
{ "Symb": "fr-FR", "Lang": "français (France)" },
{ "Symb": "es-MX", "Lang": "Español (México)" },
{ "Symb": "de-DE", "Lang": "Deutsch (Deutschland)" },
{ "Symb": "zh-CN", "Lang": "中文(中华人民共和国)" },
{ "Symb": "zh-TW", "Lang": "中文(台灣)" },
{ "Symb": "ar-QA", "Lang": "العربية (قطر)" },
{ "Symb": "id-ID", "Lang": "Bahasa Indonesia (Indonesia)" },
{ "Symb": "ja-JP", "Lang": "日本語 (日本)" },
{ "Symb": "ko-KR", "Lang": "한국어(대한민국)" },
{ "Symb": "th-TH", "Lang": "ไทย (ไทย)" }
]

class EditGeneralPreferences extends Component {

    constructor(props) {
        super(props)
        this.state = {
            UserPreferenceDetails: null,
            Redirect: false,
            IsEditToggle: false,
            IsCustomRegionalToggle: false
        };
        this.btnCancel = this.btnCancel.bind(this);
        this.btnApply = this.btnApply.bind(this);
        this.handleRadioUnitSystem = this.handleRadioUnitSystem.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
    }
    componentDidMount() {
        this.setState({ UserPreferenceDetails: this.props.UserPreference_response });
    }
    btnCancel() {
        this.setState({ Redirect: true });
    }
    handleRadioUnitSystem() {
        this.setState({ IsEditToggle: true });
    }
    handleRadio(){
        this.setState({ IsCustomRegionalToggle: true });
    }
    btnApply() {
        let label = this.props.getLabels;
        var Data = [];
        let lCulture = this.refs.ref_CustomSetting.checked ? this.refs.ref_displayLang.value : this.refs.displayLang.value;
        let lRegionalSettings = this.refs.ref_CustomSetting.checked ? 1 : 0;
        let lUnitSys = this.refs.ref_InchPounds.checked ? 0 : (this.refs.ref_InternationalSystem.checked ? 1 : 2);
        let lDateFormat = this.refs.ref_DateFormat.value === "DateMonthDayYearFormat" ? 0 : (this.refs.ref_DateFormat.value === "DateDayMonthYearFormat" ? 1 : 2);
        let lTimeFormat = this.refs.ref_TimeFormat.value === "Time12HourFormat" ? 0 : 1;
        let lNumberFormat = 0;
        if (this.refs.ref_NumberFormat.value === "Dot") lNumberFormat = 0;
        else if (this.refs.ref_NumberFormat.value === "Comma") lNumberFormat = 1;
        else if (this.refs.ref_NumberFormat.value === "DotComma") lNumberFormat = 2;
        else if (this.refs.ref_NumberFormat.value === "NoSpaceDot") lNumberFormat = 3; else lNumberFormat = 4;

        let lDateSeperator = 0;
        if (this.refs.ref_DateSeparators.value === "HyphenSeparator") lDateSeperator = 0;
        else if (this.refs.ref_DateSeparators.value === "SlashSeparator") lDateSeperator = 1;
        else if (this.refs.ref_DateSeparators.value === "DotSeparator") lDateSeperator = 2; else lDateSeperator = 3;

        let l_dimensions = label['EditPreferences.Dimension.Text'].split(',');
        let lUnitPreferences = [];

        for (let i = 0; i < 23; i++) {
            let lID = "ref_Dimension_" + l_dimensions[i].trim();
            let Value = this.refs[lID].value;
            lUnitPreferences.push({ "DimensionNumber": l_dimensions[i].trim(), "UnitNumber": Value })
        }

        Data = {
            "Culture": lCulture,
            "RegionalSettings": lRegionalSettings,
            "UnitSystem": lUnitSys,
            "DateFormat": lDateFormat,
            "TimeFormat": lTimeFormat,
            "NumberFormatType": lNumberFormat,
            "DateSeparators": lDateSeperator,
            "UnitPreferences": lUnitPreferences
        }

        this.props.UpdateUserPreferences(this.props.UserID, Data);
        this.setState({ Redirect: true });
    }

    render(getLabels, getDMLabels, UserPreference_response, UserID) {
        if (this.state.Redirect) {
            return <Redirect to={"/SystemAdmin/GeneralPreferences"} />
        }

        let label, DMlabel, datadisplay_settings;
        let IsInchPounds = false, IsInternationalSystem = false, IsCustom = false, lUnitSystem, IsCustomFormat = false, IsCustomReginal = false;
        let lCultureText = "en-US", lDateFormat, lTimeFormat, lNumberFormat, lDateSeperator, llanguages;
        label = this.props.getLabels;
        DMlabel = this.props.getDMLabels;

        if (this.state.UserPreferenceDetails !== undefined && this.state.UserPreferenceDetails !== null) {
            let data = this.state.UserPreferenceDetails;

            if (data.unitSystem === 0) {
                IsInchPounds = true;
                lUnitSystem = "EnumEditPreferences.cboUnits.IP.";
            }
            else if (data.unitSystem === 1) {
                IsInternationalSystem = true;
                lUnitSystem = "EnumEditPreferences.cboUnits.SI.";
            }
            else {
                IsCustom = true;
            }
            IsCustomFormat = data.regionalSettings === 1 ? true : false;
            IsCustomReginal = this.state.IsCustomRegionalToggle ? (this.refs.ref_CustomSetting.checked ? true : false) : IsCustomFormat;
            lCultureText = data.culture;
            lDateFormat = data.dateFormatText;
            lTimeFormat = data.timeFormatText;
            lNumberFormat = data.numberFormatText;
            lDateSeperator = data.dateSeparatorText;

            llanguages = AvailableLang.map((el, index) => {
                return <option value={el.Symb}>{el.Lang}</option>
            });

            if (label !== undefined && DMlabel !== undefined && !this.state.IsEditToggle) {
                let Selected_Dimensions = data.units;
                let l_dimensions = label['EditPreferences.Dimension.Text'];
                let dimension_lst = l_dimensions.split(',');

                if (!IsCustom) {
                    datadisplay_settings = dimension_lst.map((el, index) => {
                        let SelectedOption = Selected_Dimensions.filter(x => x.dimension === el.trim())[0];
                        let ID = "ref_Dimension_" + el.trim();
                        let lstoptions = [];
                        let lKey = (label[lUnitSystem + el.trim() + ".Text"]).split(',');
                        for (let i = 0; i < lKey.length; i++) {
                            let loptions = DMlabel["Enum3047." + lKey[i].trim() + ".Text"];
                            lstoptions.push(<option value={lKey[i].trim()}>{loptions}</option>);
                        }

                        return <tr key={index}>
                            <td>{label["EditPreferences.Dimension." + el.trim() + ".Text"]}</td>
                            <td><select ref={ID} className="custom_input default-input ComboBoxFieldStyle" defaultValue={SelectedOption.unitName}>{lstoptions}</select></td>
                        </tr>
                    });
                } else {
                    datadisplay_settings = dimension_lst.map((el, index) => {
                        let SelectedOption = Selected_Dimensions.filter(x => x.dimension === el.trim())[0];
                        let ID = "ref_Dimension_" + el.trim();
                        let lstoptions = [];
                        let lIPKey = (label["EnumEditPreferences.cboUnits.IP." + el.trim() + ".Text"]).split(',');
                        let lSIKey = (label["EnumEditPreferences.cboUnits.SI." + el.trim() + ".Text"]).split(',');
                        let lKey = lIPKey.concat(lSIKey);
                        let uniqueKeys = lKey.filter((val, id, array) => {
                            return array.indexOf(val) === id;
                        });
                        for (let i = 0; i < uniqueKeys.length; i++) {
                            let loptions = DMlabel["Enum3047." + uniqueKeys[i].trim() + ".Text"];
                            lstoptions.push(<option value={uniqueKeys[i].trim()}>{loptions}</option>);
                        }

                        return <tr key={index}>
                            <td>{label["EditPreferences.Dimension." + el.trim() + ".Text"]}</td>
                            <td><select ref={ID} className="custom_input default-input ComboBoxFieldStyle" defaultValue={SelectedOption.unit}>{lstoptions}</select></td>
                        </tr>
                    });
                }
            } else {
                let labelText = this.refs.ref_InchPounds.checked ? 'EnumEditPreferences.cboUnits.IP.' : 'EnumEditPreferences.cboUnits.SI.';
                let IsCustom = (this.refs.ref_Custom.checked ? true : false);
                let l_dimensions = label['EditPreferences.Dimension.Text'].split(',');
                if (!IsCustom) {
                    datadisplay_settings = l_dimensions.map((el, index) => {
                        let l_Key = [], l_Units = [], lstoptions = [], lDimensionID;
                        lDimensionID = el.trim();
                        let ID = "ref_Dimension_" + lDimensionID;
                        l_Key = label[labelText + lDimensionID + '.Text'].split(',');
                        for (let j = 0; j < l_Key.length; j++) {
                            l_Units = DMlabel['Enum3047.' + l_Key[j].trim() + '.Text'];
                            lstoptions.push(<option value={l_Key[j].trim()}>{l_Units}</option>);
                        }
                        return <tr>
                            <td>{label["EditPreferences.Dimension." + lDimensionID + ".Text"]}</td>
                            <td><select ref={ID} className="custom_input default-input ComboBoxFieldStyle">{lstoptions}</select></td>
                        </tr>
                    });
                } else {
                    datadisplay_settings = l_dimensions.map((el, index) => {
                        let l_Units = [], lstoptions = [], lDimensionID;
                        lDimensionID = el.trim();
                        let ID = "ref_Dimension_" + lDimensionID;
                        let lIPKey = label['EnumEditPreferences.cboUnits.IP.' + lDimensionID + '.Text'].split(',');
                        let lSIKey = label['EnumEditPreferences.cboUnits.SI.' + lDimensionID + '.Text'].split(',');
                        let lKey = lIPKey.concat(lSIKey);
                        let uniqueKeys = lKey.filter((val, id, array) => {
                            return array.indexOf(val) === id;
                        });
                        for (let j = 0; j < uniqueKeys.length; j++) {
                            l_Units = DMlabel['Enum3047.' + uniqueKeys[j].trim() + '.Text'];
                            lstoptions.push(<option value={uniqueKeys[j].trim()}>{l_Units}</option>);
                        }
                        return <tr>
                            <td>{label["EditPreferences.Dimension." + lDimensionID + ".Text"]}</td>
                            <td><select ref={ID} className="custom_input default-input ComboBoxFieldStyle">{lstoptions}</select></td>
                        </tr>
                    });
                }
            }
        }

        return (
            <div className="main_container huge_container_data">
              <div className="clear">
                <h2 className="dbd_sub_heading">{label['EditPreferences.Title.Text'] !== undefined ? label['EditPreferences.Title.Text'] : "Edit Preferences"} </h2>
                {/* <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" />
                <FaPrint className="dbd_right_icon Ensemble_Icon print_icon link_cursor" /> */}
                &nbsp;
               </div>
                <Label className="sub_text">{label['EditPreferences.lblUserAsstMessage.Text'] !== undefined ? label['EditPreferences.lblUserAsstMessage.Text'] : "Complete this page and click Save."}</Label>
                <br />

                <div className="sub_text">
                    <legend className="form_sub_title">{label['EditPreferences.lblDisplayUnitsHeading.Text'] !== undefined ? label['EditPreferences.lblDisplayUnitsHeading.Text'] : "Data Display Units"}</legend>
                    <Label>{label['EditPreferences.lblDisplayUnitsUserAsstMsg.Text'] !== undefined ? label['EditPreferences.lblDisplayUnitsUserAsstMsg.Text'] : "Select Inch-Pound (IP) or International System (SI) for all the standard units or select Custom and specify each unit of measurement."}</Label>
                    <div>
                        <FormGroup check >
                            <Label check>
                                <input type="radio" ref="ref_InchPounds" name="rdMeasurementType" value="0" key={IsInchPounds} defaultChecked={IsInchPounds} onChange={this.handleRadioUnitSystem} />
                                {label['EditPreferences.rbtnInchPounds.Text'] !== undefined ? label['EditPreferences.rbtnInchPounds.Text'] : "Inch-Pounds(IP)"}
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <input type="radio" ref="ref_InternationalSystem" name="rdMeasurementType" value="1" key={IsInternationalSystem} defaultChecked={IsInternationalSystem} onChange={this.handleRadioUnitSystem} />
                                {label['EditPreferences.rbtnInternationalSystem.Text'] !== undefined ? label['EditPreferences.rbtnInternationalSystem.Text'] : "International System(SI)"}
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <input type="radio" ref="ref_Custom" name="rdMeasurementType" value="2" key={IsCustom} defaultChecked={IsCustom} onChange={this.handleRadioUnitSystem} />
                                {label['EditPreferences.rbtnCustom.Text'] !== undefined ? label['EditPreferences.rbtnCustom.Text'] : "Custom"}
                            </Label>
                        </FormGroup>
                    </div>
                    <div className="table_container">
                        <Table striped responsive className="Custom_table general_prefereces_tbl">
                            <tbody>
                                <tr><th>{label['Preferences.Columns.DataType.Text'] !== undefined ? label['Preferences.Columns.DataType.Text'] : "Data Type"}</th><th>{label['Preferences.Columns.Units.Text'] !== undefined ? label['Preferences.Columns.Units.Text'] : "Unit"}</th></tr>
                                {datadisplay_settings}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="sub_text">
                    <legend className="form_sub_title">{label['EditPreferences.lblRegionalSettingsHeading.Text'] !== undefined ? label['EditPreferences.lblRegionalSettingsHeading.Text'] : "Regional Settings"}</legend>
                    <Label>{label['EditPreferences.lblUserAsstMessageRegionalSettings.Text'] !== undefined ? label['EditPreferences.lblUserAsstMessageRegionalSettings.Text'] : "Select your country from the list for its standard regional settings, or select Custom settings and specify each setting."}</Label>
                    <div style={{ "width": "60%" }}>
                        <FormGroup check >
                            <Label check>
                                <input type="radio" ref="ref_Regional" name="rdRegionalType" value="0" key={!IsCustomFormat} defaultChecked={!IsCustomFormat} onChange={this.handleRadio} />
                                {label['EditPreferences.rbtnRegional.Text'] !== undefined ? label['EditPreferences.rbtnRegional.Text'] : "Use the language, date format and time format for"}
                            </Label>
                            <select ref='displayLang' disabled={IsCustomReginal} key={lCultureText} defaultValue={lCultureText} style={{ "float": "right" }} className="custom_input default-input ComboBoxFieldStyle">
                                {llanguages}
                            </select>
                        </FormGroup>
                        <br />
                        <FormGroup check>
                            <Label check>
                                <input type="radio" ref="ref_CustomSetting" name="rdRegionalType" value="1" key={IsCustomFormat} defaultChecked={IsCustomFormat} onChange={this.handleRadio} />
                                {label['EditPreferences.rbtnCustomSettings.Text'] !== undefined ? label['EditPreferences.rbtnCustomSettings.Text'] : "Custom Settings"}
                            </Label>
                        </FormGroup>
                    </div>
                    <div className="table_container">
                        <Table striped responsive className="Custom_table general_prefereces_tbl">
                            <tbody>
                                <tr><th>{label['EditPreferences.Columns.Preference.Text']}</th><th >{label["Preferences.Columns.Value.Text"]}</th></tr>
                                <tr>
                                    <td>{label['EditPreferences.Columns.Language.Text']}</td>
                                    <td>
                                        <select ref='ref_displayLang' disabled={!IsCustomReginal} key={lCultureText} defaultValue={lCultureText} className="custom_input default-input ComboBoxFieldStyle">
                                            {llanguages}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{label['EditPreferences.Columns.DateFormat.Text']}</td>
                                    <td>
                                        <select ref='ref_DateFormat' disabled={!IsCustomReginal} key={lDateFormat} defaultValue={lDateFormat} className="custom_input default-input ComboBoxFieldStyle">
                                            <option value="DateMonthDayYearFormat" key="0">{label['EditPreferences.DateFormat.DateMonthDayYearFormat.Text'] !== undefined ? label['EditPreferences.DateFormat.DateMonthDayYearFormat.Text'] : "Month Day Year"}</option>
                                            <option value="DateDayMonthYearFormat" key="1">{label['EditPreferences.DateFormat.DateDayMonthYearFormat.Text'] !== undefined ? label['EditPreferences.DateFormat.DateDayMonthYearFormat.Text'] : "Day Month Year"}</option>
                                            <option value="DateYearMonthDayFormat" key="2">{label['EditPreferences.DateFormat.DateYearMonthDayFormat.Text'] !== undefined ? label['EditPreferences.DateFormat.DateYearMonthDayFormat.Text'] : "Year Month Day"}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{label['EditPreferences.Columns.TimeFormat.Text']}</td>
                                    <td>
                                        <select ref='ref_TimeFormat' disabled={!IsCustomReginal} key={lTimeFormat} defaultValue={lTimeFormat} className="custom_input default-input ComboBoxFieldStyle">
                                            <option value="Time12HourFormat" key="0">{label['EditPreferences.TimeFormat.Time12HourFormat.Text'] !== undefined ? label['EditPreferences.TimeFormat.Time12HourFormat.Text'] : "12-Hour"}</option>
                                            <option value="Time24HourFormat" key="1">{label['EditPreferences.TimeFormat.Time24HourFormat.Text'] !== undefined ? label['EditPreferences.TimeFormat.Time24HourFormat.Text'] : "24-Hour"}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{label['EditPreferences.Columns.NumberFormat.Text']}</td>
                                    <td>
                                        <select ref='ref_NumberFormat' disabled={!IsCustomReginal} key={lNumberFormat} defaultValue={lNumberFormat} className="custom_input default-input ComboBoxFieldStyle">
                                            <option value="Dot" key="0">{label['EditPreferences.NumberFormat.Dot.Text'] !== undefined ? label['EditPreferences.NumberFormat.Dot.Text'] : "9,999,999.99"}</option>
                                            <option value="Comma" key="1">{label['EditPreferences.NumberFormat.Comma.Text'] !== undefined ? label['EditPreferences.NumberFormat.Comma.Text'] : "9 999 999,99"}</option>
                                            <option value="DotComma" key="2">{label['EditPreferences.NumberFormat.DotComma.Text'] !== undefined ? label['EditPreferences.NumberFormat.DotComma.Text'] : "9.999.999,99"}</option>
                                            <option value="NoSpaceDot" key="3">{label['EditPreferences.NumberFormat.NoSpaceDot.Text'] !== undefined ? label['EditPreferences.NumberFormat.NoSpaceDot.Text'] : "9999999.99"}</option>
                                            <option value="NoSpaceComma" key="4">{label['EditPreferences.NumberFormat.NoSpaceComma.Text'] !== undefined ? label['EditPreferences.NumberFormat.NoSpaceComma.Text'] : "9999999,99"}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{label['EditPreferences.Columns.DateSeparators.Text']}</td>
                                    <td>
                                        <select ref='ref_DateSeparators' disabled={!IsCustomReginal} key={lDateSeperator} defaultValue={lDateSeperator} className="custom_input default-input ComboBoxFieldStyle">
                                            <option value="HyphenSeparator" key="0">{label['EditPreferences.DateSeparators.HyphenSeparator.Text'] !== undefined ? label['EditPreferences.DateSeparators.HyphenSeparator.Text'] : "Hyphen(-)"}</option>
                                            <option value="SlashSeparator" key="1">{label['EditPreferences.DateSeparators.SlashSeparator.Text'] !== undefined ? label['EditPreferences.DateSeparators.SlashSeparator.Text'] : "Slash(/)"}</option>
                                            <option value="DotSeparator" key="2">{label['EditPreferences.DateSeparators.DotSeparator.Text'] !== undefined ? label['EditPreferences.DateSeparators.DotSeparator.Text'] : "Period(.)"}</option>
                                            <option value="UnderscoreSeparator" key="3">{label['EditPreferences.DateSeparators.UnderscoreSeparator.Text'] !== undefined ? label['EditPreferences.DateSeparators.UnderscoreSeparator.Text'] : "Underscore(_)"}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
                <FormGroup row className="btns_group">
                    <Col sm={{ size: 10 }}>
                        <Button className="btn-gray btn-md" onClick={this.btnCancel}>Cancel</Button>
                        <Button className="btn-success btn-md" onClick={this.btnApply}>Apply</Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
        UpdateUserPreferences: (ID, data) => dispatch(UpdateUserPreferences(ID, data))
    };
};

const mapStateToProps = state => {
    return {
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
        getDMLabels: state.CulturalLabelsRootReducer.DMResource_LabelsBasedOnPreference,
        UserID: state.userDetailsRootReducer.user_info.id
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGeneralPreferences);
